import script from "./AudioController.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioController.vue?vue&type=script&setup=true&lang=ts"

import "./AudioController.vue?vue&type=style&index=0&id=5c4a94e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4a94e0"]])

export default __exports__